export const FETCH_SIZES_REQUESTED = 'FETCH_SIZES_REQUESTED';
export const FETCH_SIZES_SUCCEEDED = 'FETCH_SIZES_SUCCEEDED';
export const SORT_SIZES_REQUESTED = 'SORT_SIZES_REQUESTED';
export const SORT_SIZES_SUCCEEDED = 'SORT_SIZES_SUCCEEDED';
export const FILTER_SIZE_SUCCEEDED = 'FILTER_SIZE_SUCCEEDED';
export const FILTER_SIZE_REQUESTED = 'FILTER_SIZE_REQUESTED';



export const GET_SIZE_CONVERSION_REQUESTED = "GET_SIZE_CONVERSION_REQUESTED";
export const GET_SIZE_CONVERSION_SUCCEEDED = "GET_SIZE_CONVERSION_SUCCEEDED";
